<template>
  <div v-if="showBanner" class="banner">
    <span></span>
    <div class="banner-contents content">
      <div class="left-side">
        <span class="banner-headline"
          >You are viewing the legacy Dashboard which has the old URL format and will soon be
          removed •
        </span>
        <span class="banner-message"
          >Please re-navigate to the newest version of this dashboard using the left side panel and
          bookmark the new URL if needed.</span
        >
      </div>
    </div>
    <v-btn text icon color="#ff0000" @click="dismiss">
      <v-icon>close</v-icon>
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const showBanner = ref(true)
const dismiss = () => {
  showBanner.value = false
}
</script>

<style scoped>
.banner {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  background-color: #ffc5c5;
  padding: 8px 16px;
  color: #ff0000;
}

.banner-contents {
  font-weight: 400;
  font-size: 18px;
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
}

@keyframes slide-in {
  from {
    transform: translateY(-100%);
    opacity: 1;
  }
  to {
    transform: translateY(0%);
    opacity: 1;
  }
}

.content {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.left-side {
  text-align: left;
  line-height: 1.14;
}

.banner-headline {
  font-weight: bold;
  font-size: 10pt;
  display: block;
  float: left;
  padding-right: 3px;
}

.banner-message {
  font-size: 10pt;
  font-weight: 500;
  display: block;
  float: left;
}
</style>
